var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg062Switch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380,124H132C59.215,124,0,183.215,0,256s59.215,132,132,132h73c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20h-73 c-50.729,0-92-41.271-92-92s41.271-92,92-92h153.429C262.278,187.792,248,220.26,248,256c0,72.785,59.215,132,132,132 s132-59.215,132-132S452.785,124,380,124z M380,348c-50.729,0-92-41.271-92-92s41.271-92,92-92s92,41.271,92,92 S430.729,348,380,348z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg062Switch);
export default __webpack_public_path__ + "static/media/062-switch.aec3ee24b01cb56f296b5585621ddc5f.svg";
export { ForwardRef as ReactComponent };